export const actionTypes = {
  START_REQUEST: 'APP.SITE_MAP.START_REQUEST',
  REQUEST_SUCCESS: 'APP.SITE_MAP.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.SITE_MAP.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.START_REQUEST,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
